const data = {
  voucher: require('./voucher.js'),
  cinemaDeal: require('./cinemaDeal.js'),
  socialDeal: require('./socialDeal.js'),
  steakMenu: require('./steakMenu.js'),
  kidsMenu: require('./kidsMenu.js'),
  voucherThreeCourse: require('./voucherThreeCourse.js'),
  voucherLunchdeal: require('./voucherLunchdeal.js'),
  voucherDinerdeal: require('./voucherDinerdeal.js'),
  loversBurger: require('./loversBurger.js')
}

module.exports = data
